import { TAction } from "../../base/types/redux";
import ReducerRegistry from "../../base/redux/ReducerRegistry";
import { ACTION_TYPES } from "./actionTypes";

const initState: any = {
  ekycList: [],
  healthCheckList: [],
  personalHealthCheckDetails: null,
  getFilterEkycState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  getImportEkycState: {
    isFetching: false,
    isSuccess: null,
    isFail: null,
    data: null
  },
  getSendEmailEkycResultState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  getFilterHealthCheckState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  filterOptions: [],
  filterEkycOptions: [],
  getConfirmBatchHealthCheckState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  getSendEmailBatchHealthCheckState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  getConfirmHealthCheckState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  getDetails: {},
  getSendEmailHealthCheckState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
};

const reducer = (state = initState, action: TAction) => {
  switch (action.type) {
    case ACTION_TYPES.SET_FILTER_EKYC_STATE: {
      return {
        ...state,
        getFilterEkycState: action.response,
      };
    }
    case ACTION_TYPES.SET_EKYC_LIST: {
      return {
        ...state,
        ekycList: action.response.data?.content,
      };
    }
    case ACTION_TYPES.SET_IMPORT_EKYC_STATE: {
      return {
        ...state,
        getImportEkycState: action.response,
      };
    }
    case ACTION_TYPES.SET_SEND_EMAIL_EKYC_RESULT_STATE: {
      return {
        ...state,
        getSendEmailEkycResultState: action.response,
      };
    }
    case ACTION_TYPES.SET_FILTER_HEALTH_CHECK_STATE: {
      return {
        ...state,
        getFilterHealthCheckState: action.response,
      };
    }
    case ACTION_TYPES.SET_HEALTH_CHECK_LIST: {
      return {
        ...state,
        healthCheckList: action.response.data?.content,
      };
    }
    case ACTION_TYPES.SET_FILTER_OPTIONS: {
      return {
        ...state,
        filterOptions: action.response.data,
      };
    }
    case ACTION_TYPES.SET_CONFIRM_BATCH_HEALTH_CHECK_STATE: {
      return {
        ...state,
        getConfirmBatchHealthCheckState: action.response,
      };
    }
    case ACTION_TYPES.SET_SEND_EMAIL_BATCH_HEALTH_CHECK_STATE: {
      return {
        ...state,
        getSendEmailBatchHealthCheckState: action.response,
      };
    }
    case ACTION_TYPES.SET_PERSONAL_HEALTH_CHECK_DETAILS: {
      return {
        ...state,
        personalHealthCheckDetails: action.response,
      };
    }
    case ACTION_TYPES.SET_CONFIRM_HEALTH_CHECK_STATE: {
      return {
        ...state,
        getConfirmHealthCheckState: action.response,
      };
    }
    case ACTION_TYPES.SET_DETAILS: {
      return {
        ...state,
        getDetails: action.response?.data,
      };
    }
    case ACTION_TYPES.SET_SEND_EMAIL_HEALTH_CHECK_STATE: {
      return {
        ...state,
        getSendEmailHealthCheckState: action.response,
      };
    }
    case ACTION_TYPES.SET_FILTER_EKYC_OPTIONS: {
      return {
        ...state,
        filterEkycOptions: action.response.data,
      };
    }
    default:
      return state;
  }
};

ReducerRegistry.register("sbo", reducer);
